import  logo  from '../images/logo-header.png';
import  basking  from '../images/basking-shark-logo.png';
import {Link} from 'react-router-dom';

const Footer = () => {
  return (
    <>
    <footer>
      <div className="container">
        <div className="dflex space-between ptb30">
            <img src={logo} className='footer-logo' alt="" />

            <img src={basking} className='footer-logo' alt="" />
        </div>
  
        

      <div className="dflex space-between mainfooter">
        <div className='footer-link'>
            <p className='uppercase ff'>SALES OFFICE:<br />
               GODOWN NO. 458,<br />
               JAI BHAWANI INDUSTRIAL ESTATE,<br />
               NEAR ST. XAVIER’S SCHOOL GATE,<br /> NO 4, GHODBUNDER ROAD,<br />
               CHITALSAR VILLAGE, MANPADA <br /> 
               THANE, 400 607, INDIA.
            </p>
        </div>  

        <div className='footer-link m-none'>
            <ul>
                <li><Link to="/home" className='uppercase'>Home</Link></li>
                <li><Link to="/about-us" className='uppercase'>ABOUT US</Link></li>
                <li><Link to="/services" className='uppercase'>SERVICES</Link></li>
                <li><Link to="/music" className='uppercase'>MUSIC</Link></li>
                <li><Link to="/movies" className='uppercase'>MOVIES</Link></li>
                <li><Link to="/contact-us" className='uppercase'>CONTACT</Link></li>
            </ul>
        </div>  

        <div className='footer-link m-none'>
            <ul>
                <li><Link to="/new-release-hindi" className='uppercase'>New Release - Hindi</Link></li>
                <li><Link to="/new-release-english" className='uppercase'>New Release - English</Link></li>
                <li><Link to="/new-release-tamil" className='uppercase'>New Release - Tamil</Link></li>
                <li><Link to="/pre-book" className='uppercase'>Pre-Book</Link></li>
                <li><Link to="/exclusive-products" className='uppercase'>Exclusive</Link></li>
                <li><Link to="/bestsellers-hindi" className='uppercase'>Best Sellers - Hindi</Link></li>
                <li><Link to="/bestsellers-english" className='uppercase'>Best Sellers - English</Link></li>
                <li><Link to="/box-sets" className='uppercase'>Box sets</Link></li>

                {/* <li><Link to="/exclusive-products" className='uppercase'>EXCLUSIVES</Link></li>
                <li><Link to="/new-releases-products" className='uppercase'>NEW RELEASES</Link></li>
                <li><Link to="/upcoming-releases-products" className='uppercase'>Pre-Book</Link></li>
                <li><Link to="/bestsellers-products" className='uppercase'>BESTSELLERS</Link></li>
                <li><Link to="/sitemap" className='uppercase'>SITEMAP</Link></li> */}
            </ul>
            
        </div>  

        <div className='footer-link m-none'>
            <ul>
                <li><Link to="https://www.facebook.com/blisstainment/" target='_blank' className='uppercase'><i className="fa fa-facebook"></i> <span>/BLISSTAINMENT</span></Link></li>
                <li><Link to="https://www.instagram.com/blisstainment1?utm_medium=copy_link" target='_blank' className='uppercase'><i className="fa fa-instagram"></i> <span>/BLISSTAINMENT</span></Link></li>
                <li><Link to="https://www.linkedin.com/in/blisstainment-a1b403209/" target='_blank' className='uppercase'><i className="fa fa-linkedin"></i> <span>/BLISSTAINMENT</span></Link></li>
                <li><Link to="https://x.com/Blisstainment_1" target='_blank' className='uppercase'><i className="fa fa-twitter"></i> <span>/BLISSTAINMENT</span></Link></li>
                <li><Link to="tel:+91 85910 10516" className='uppercase'><i className="fa fa-phone"></i> <span>/+91 85910 10516</span></Link></li>
                <li><Link to="mailto:info@blisstainment.com" className='uppercase'><i className="fa fa-envelope"></i> <span>/info@blisstainment.com</span></Link></li>
            </ul>
        </div>  

        <div className='footer-link'>
            <p className='uppercase ff'>
               REGISTERED OFFICE:<br />
               B-06, SATYAVANDAN,<br />
               KOLSHET ROAD,<br />
               THANE, 400 607,<br />
               INDIA.
            </p>
        </div>    
      </div>
      </div>  
    </footer> 

    <section style={{backgroundColor:'#808080cc', color:'#fff'}}>
        <div className='container'>
         <div className="dflex content-center fs13">
            <p className='border-left pd ff'>All rights reserved by @blisstainment.com</p>
            <p className='border-left pd ff'><Link to={'/terms'} className='disclaimer_title'>Disclaimer</Link></p>
            <p className='border-left pd ff'><Link to={'/terms'} className='disclaimer_title'>Privacy Policy</Link></p>
            <p className='pd ff'><Link to={'/sitemap'} className='disclaimer_title'>Site Map</Link></p>
        </div>
        </div>
    </section>

    </>
  )
}

export default Footer
